import { colors } from '@aloft/toolkit-sui';

import { TableConfig, TableConfigKey } from './types.ts';

export const BORDER = `1px solid ${colors.strokeDefault}`;

export const TABLE_CONFIGS: Record<TableConfigKey, TableConfig> = {
  additionalStructures: { columnWidths: [6, 8, 8, 12, 14, 14, 14, 14, 10] },
  condition: { columnWidths: [8, 12, 16, 16, 16, 16, 16] },
  externalDepreciation: { columnWidths: [8, 30, 30, 32] },
  functionalDepreciation: { columnWidths: [8, 30, 30, 32] },
  quality: { columnWidths: [8, 8, 16, 16, 16, 10, 13, 13] },
  siteExtraction: { columnWidths: [6, 19, 10, 8, 9, 10, 7, 8, 10, 10] },
  marketConditions: { columnWidths: [24, 14, 14, 14, 14, 14, 14] },
};
